import React from "react";
import propTypes from "prop-types";
import Checkout from "./Checkout";
import Thanks from "./Thanks";
import { MainContainer } from "./styles";
export default function Main(props) {
  const {
    auth,
    clearSFLead,
    location,
    newInquiry,
    newLead,
    removeFromCart,
    user,
  } = props;
  const { inquirySuccess, loading, mobile } = user;
  const { state } = location;

  return (
    <MainContainer>
      {inquirySuccess ? (
        <Thanks {...props} />
      ) : (
        <div>
          <Checkout
            removeFromCart={removeFromCart}
            newInquiry={newInquiry}
            newLead={newLead}
            clearSFLead={clearSFLead}
            auth={auth}
            loading={loading}
            mobile={mobile}
            username={user.username}
            userToken={auth.user.access_token}
            videos={state && state.videos ? state.videos : []}
            lead={state && state.lead ? state.lead : ""}
          />
        </div>
      )}
    </MainContainer>
  );
}

Main.propTypes = {
  auth: propTypes.object,
  user: propTypes.object,
  location: propTypes.object,
  clearSFLead: propTypes.func,
};